import { deleteRequest, getRequest, postRequest, putRequest } from '..';

export function add(data) {
  return postRequest('/job', data);
}

export function edit(data) {
  return putRequest(`/job/${data.id}`, data)
}

export function get(id) {
  return getRequest(`/job/${id}`);
}

export function getAll() {
  return postRequest(
    '/job/1',
    {
      "currentPage": 1,
      "pageSize": 8008135,
    },
  ).then(({ jobs }) => jobs);
}

export function remove(id) {
  return deleteRequest(`/job/${id}`);
}
